import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const KenyaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15256'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15256)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 3.73333H20V0H0V3.73333Z'
					fill='#262626'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14.0001H20V10.2667H0V14.0001Z'
					fill='#018301'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 10.2666H20V3.73328H0V10.2666Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 9.33329H20V4.66663H0V9.33329Z'
					fill='#DC0808'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.0001 11.6667C10.9525 11.6667 12.381 9.8351 12.381 7.00004C12.381 4.16498 10.9525 2.33337 10.0001 2.33337C9.04771 2.33337 7.61914 4.16498 7.61914 7.00004C7.61914 9.8351 9.04771 11.6667 10.0001 11.6667Z'
					fill='#BC0000'
				/>
				<mask
					id='mask1_2332_15256'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='7'
					y='2'
					width='6'
					height='10'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M10.0001 11.6667C10.9525 11.6667 12.381 9.8351 12.381 7.00004C12.381 4.16498 10.9525 2.33337 10.0001 2.33337C9.04771 2.33337 7.61914 4.16498 7.61914 7.00004C7.61914 9.8351 9.04771 11.6667 10.0001 11.6667Z'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask1_2332_15256)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M6.1915 12.1334C7.50646 12.1334 8.57245 9.83509 8.57245 7.00003C8.57245 4.16497 7.50646 1.8667 6.1915 1.8667C4.87654 1.8667 3.81055 4.16497 3.81055 7.00003C3.81055 9.83509 4.87654 12.1334 6.1915 12.1334Z'
						fill='#262626'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M13.8087 12.1334C15.1237 12.1334 16.1896 9.83509 16.1896 7.00003C16.1896 4.16497 15.1237 1.8667 13.8087 1.8667C12.4937 1.8667 11.4277 4.16497 11.4277 7.00003C11.4277 9.83509 12.4937 12.1334 13.8087 12.1334Z'
						fill='#262626'
					/>
					<g filter='url(#filter0_d_2332_15256)'>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M9.99963 5.60003C10.2626 5.60003 10.4758 4.7643 10.4758 3.73337C10.4758 2.70243 10.2626 1.8667 9.99963 1.8667C9.73664 1.8667 9.52344 2.70243 9.52344 3.73337C9.52344 4.7643 9.73664 5.60003 9.99963 5.60003ZM10 8.40003C10.2628 8.39945 10.4758 7.77287 10.4758 7.00003C10.4758 6.22683 10.2626 5.60003 9.99963 5.60003C9.73664 5.60003 9.52344 6.22683 9.52344 7.00003C9.52344 7.77323 9.73664 8.40003 9.99963 8.40003C9.73664 8.40003 9.52344 9.23577 9.52344 10.2667C9.52344 11.2976 9.73664 12.1334 9.99963 12.1334C10.2626 12.1334 10.4758 11.2976 10.4758 10.2667C10.4758 9.23625 10.2628 8.40081 10 8.40003Z'
							fill='url(#paint0_linear_2332_15256)'
						/>
					</g>
				</g>
			</g>
			<defs>
				<filter
					id='filter0_d_2332_15256'
					x='9.52344'
					y='1.8667'
					width='0.953125'
					height='11.2667'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='1' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_15256'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_15256'
						result='shape'
					/>
				</filter>
				<linearGradient
					id='paint0_linear_2332_15256'
					x1='9.52344'
					y1='1.8667'
					x2='9.52344'
					y2='12.1334'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='white' />
					<stop
						offset='1'
						stopColor='#F0F0F0'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default KenyaFlagIcon;
